import React from "react";
import _ from 'i18n';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend, ResponsiveContainer, ComposedChart, Bar
} from "recharts";
import { CommonLoader } from "../../../../common/CommonLoader";
import { formatAmount } from "../../../../../services/utils";
import RegistrationCAFilter from "../../../../Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter";


const prepareData = ({ data1, data2, language, chartLinesToShow, startMonth, endMonth, type, frequency }) => {
  const data = data2.map((item, index) => {
    let obj = { "data1-sum": 0, "data2-sum": 0 };
    for (let key in item) {
      if (key !== "name" && chartLinesToShow.includes(key)) {
        obj["data2-" + key] = item[key];
        obj["data2-sum"] += item[key];
        obj["data1-" + key] = data1[index] ? data1[index][key] : 0;
        obj["data1-sum"] += data1[index] ? data1[index][key] : 0;

        if (type === 'CA') {
          obj["data2-" + key] /= 100;
          obj["data1-" + key] /= 100;
        }
      }

      if (key === "name") {
        obj["name"] = language !== 'fr' ? _(item.name) : item.name;
      }
    }

    if (type === 'CA') {
      obj["data2-sum"] /= 100;
      obj["data1-sum"] /= 100;
    }

    return obj;
  });

  return frequency === 'DAILY' ? data : data.filter((elem, index) => startMonth <= index + 1 && index + 1 <= endMonth);
};

const getBars = (keys) => {
  return keys.map((key, index) => {
    let stackId = key.includes("data1") ? "data1" : "data2";
    let fill;

    if (key.includes("formations")) {
      fill = "#18A0FB";
    } else if (key.includes("cycles_essential")) {
      fill = "#14B7AD";
    } else if (key.includes("cycles")) {
      fill = "#5F5DE8";
    } else if (key.includes("saisons")) {
      fill = "#F47F4D";
    } else if (key.includes("monthly_premium")) {
      fill = "#FB1E5B";
    } else if (key.includes("yearly_premium")) {
      fill = "#FFD433";
    } else if (key.includes("congrès")) {
      fill = "#6D7F92";
    }

    return (
      <Bar key={key} dataKey={key} stackId={stackId} fill={fill} opacity={stackId == "data2" ? 0.5 : 1} />
    );
  });
};


const CompareStatsChart = ({ data1, data2, language, chartLinesToShow, startMonth, endMonth, type, frequency, year1, year2, fetching, updateType }) => {

  const preparedData = prepareData({ data1, data2, language, chartLinesToShow, startMonth, endMonth, type, frequency });

  const preparedDataKeys = preparedData.length > 0 ? Object.keys(preparedData[0]).filter(key => !['name', 'data1-sum', 'data2-sum'].includes(key)) : [];
  const bars = getBars(preparedDataKeys);

  const legendPayload = [
    { value: year2, type: 'line', color: '#464646b3', id: 'data2-sum' },
    { value: year1, type: 'line', color: '#000', id: 'data1-sum' },
  ];

  return (
    <React.Fragment>
      <div style={{ width: '100%' }}>
        <RegistrationCAFilter type={type} updateType={updateType} />
      </div>
      {
        fetching === true ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
          <ResponsiveContainer width={'100%'} height={300}>
            <ComposedChart
              data={preparedData}
              margin={{
                top: 10,
                right: 30
              }}
              style={{
                fontSize: '12px',
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400
              }}
            >
              <CartesianGrid stroke="#D8DDE2" vertical={false} strokeDasharray="4" />
              <XAxis dataKey="name" tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} />
              <YAxis tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} allowDecimals={false} />
              <Tooltip content={({ active, payload, label }) => {
                if (active) {
                  return (
                    <div style={{
                      backgroundColor: '#ffffff',
                      padding: '10px',
                      borderRadius: '5px',
                      border: '1px solid gray'
                    }}>
                      <p>{label}</p>
                      {
                        payload && payload.filter(p => ["data1-sum", "data2-sum"].includes(p.dataKey)).map(p => (
                          <p key={p.dataKey}
                            style={{ color: p.stroke, fontSize: '14px' }}>
                            {legendPayload.find(legend => legend.id === p.dataKey).value}: {type === 'CA' ? formatAmount(p.value, false) : p.value}
                          </p>
                        ))
                      }
                    </div>
                  );
                }
                return null;
              }} />
              {bars}
              <Line
                dataKey={"data1-sum"}
                stroke="#000"
                type='monotone'
                strokeWidth={2}
                isAnimationActive={true}
                animationDuration={2000}
                animationEasing="ease-out"
              />
              <Line
                dataKey={"data2-sum"}
                stroke="#464646b3"
                type='monotone'
                strokeWidth={2}
                isAnimationActive={true}
                animationDuration={2000}
                animationEasing="ease-out"
              />
              <Legend payload={legendPayload} iconType="line" />
            </ComposedChart>
          </ResponsiveContainer>
      }
    </React.Fragment>
  );
};

export default CompareStatsChart;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CompareStats/CompareStatsChart.js